<template>
    <div>
        <div class="edit-mask">
            <div class="edit-wrapper">
                <div class="edit-container">
                    <button @click="$emit('modalclose')" class="edit-close"><img width="15px" src="../assets/img/mymenu_x.png"/></button>
                    <h1 class="edit-title">편집하기</h1>
                    <div class="tabs help-tabs">
                        <ul>
                            <li :class="[ tab === 0 ? 'is-active' : '']"><a @click="tab=0">핵심 기사 선택</a></li>
                            <li :class="[ tab === 1 ? 'is-active' : '']"><a @click="tab=1">주요 기사 선택</a></li>
                        </ul>
                    </div>
                    <div class="help-content">
                        <div v-if="tab === 0">
                            <div class="edit-complete-article">
                                <label v-for="(article, index) in articles_foredit" :key="index">
                                    <input v-if="index == 0" v-model="headlineIndex" :value="index" id="headline-radio" name="radio-group" type="radio" checked="checked"/>
                                    <input v-else v-model="headlineIndex" :value="index" id="headline-radio" name="radio-group" type="radio" />
                                    <div class="edit-complete-article-item">
                                    <p class="edit-article-title">{{ article.title }}</p>
                                    <p class="edit-article-sub">{{ article.title_sub }}</p>
                                    <p class="edit-article-tags">
                                        #<span>{{ sections[article.section-1] }}</span>
                                        #<span>{{ article.word }}</span>
                                        <span>{{ article.hashtag }}</span>
                                    </p>
                                    </div>
                                </label>
                            </div>
                            <button class="edit-button" @click="changeTab">다음</button>
                        </div>
                        <div v-if="tab === 1">
                            <div class="edit-complete-article">
                                <label v-for="(article, index) in articles_foredit" :key="index">
                                    <input v-if="index == headlineIndex" v-model="mainIndex" :value="index" id="main-checkbox" name="checkbox-group" type="checkbox" disabled/>
                                    <input v-else v-model="mainIndex" :value="index" id="main-checkbox" name="checkbox-group" type="checkbox" />
                                    <div class="edit-complete-article-item">
                                    <p class="edit-article-title">{{ article.title }}</p>
                                    <p class="edit-article-sub">{{ article.title_sub }}</p>
                                    <p class="edit-article-tags">
                                        #<span>{{ sections[article.section-1] }}</span>
                                        #<span>{{ article.word }}</span>
                                        <span>{{ article.hashtag }}</span>
                                    </p>
                                    </div>
                                </label>
                            </div>
                            <p class="edit-main-info">{{ invaildIndex }}</p>
                            <button class="edit-button" @click="changeTab">뒤로 가기</button>
                            <button class="edit-button edit-button-end" @click="finishededit">확인</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapGetters } from 'vuex'
export default {
    data(){
        return{
            headlineIndex : 0,
            invaildIndex : '주요기사는 2개 선택해주세요.',
            mainIndex: [],
            tab: 0,
        }
    },
    computed:{
        ...mapState([
            'sections',
            'articles',
        ]),
        ...mapGetters([
            'session_PE',
            'articles_foredit'
        ])
    },
    methods: {
        changeTab(){
            this.tab = (this.tab+1) % 2
            this.mainIndex =[]
            this.$emit('sendheadline', this.headlineIndex)
        },
        finishededit(){
            if ((this.mainIndex).length > 2 && (this.articles_foredit).length > 2){
                this.invaildIndex = '주요기사는 2개만 선택해 주세요.'
            }
            else if ((this.mainIndex).length < 2 && (this.articles_foredit).length > 2){
                this.invaildIndex = '주요기사 2개를 선택하셔야 편집이 완료됩니다.'
            }
            else {
            this.$emit('sendheadline', this.headlineIndex)
            this.$emit('sendmain', this.mainIndex)
            this.$emit('modalclose')
            }
        } 
  }

}
</script>

<style>
.edit-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.edit-close{
    float: right;
    background: none;
    border: none;
}
.edit-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.edit-container {
  width: inherit;
  height: 100%;
  margin: 0px auto;
  padding: 20px 30px;

  background-color:#c9c9c9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  overflow: scroll
}
.help-tabs {
    margin-bottom: 10px !important;
}
.tabs ul {
    justify-content: center !important;
    border: none;
}
.tabs li.is-active a {
    align-content: center;
    border-bottom-color: #000000;
    color: #000000;
    border-bottom: 3px solid;
    font-weight: bold;
}
.edit-title{
    text-align: center;
    font-size: 1.2em;
    font-family: 'Helvetica', Courier, monospace;
    font-weight: bold;
}
.edit-complete-article {
    border:black 1px solid;
    background-color: white;
    margin-bottom: 1em;
    min-height: 300px;
    max-height: 300px;
    overflow: scroll;
}
#headline-radio, #main-checkbox{
    width: 0;
    height: 0;
    float: right;
}
#headline-radio:checked + div{
  background-color: yellow;
}
#main-checkbox:checked + div {
    background-color: orange;
}
#main-checkbox:disabled + div{
  background-color: lightgray;
  color: gray;
}
.edit-complete-article-item{
    padding: 0.5em;
    border-bottom: gray 1px dotted;
}
.edit-article-title{
    font-weight: bold;
}
.edit-article-sub{
    font-size: 0.9em;
}
.edit-article-tags{
    font-size: small
}
.edit-main-info{
    text-align: center;
}
.edit-button {
  display: block;
  background-color: black;
  color: white;
  text-align: center;
  font-size: 1em;
  width: 60%;
  margin: 2% 20%;
  border: none;
  padding: 2%;
}
.edit-button-end{
  margin-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/editArticle.vue